import React, { ReactElement } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { ReportHtml } from '../../elements/ReportHtml'
import { ReportsSkeleton } from '../../elements/ReportsSkeleton'
import { BalanceSheet as BalanceSheetNL } from '../NL/balanceSheet'
import { BalanceTableActions } from './elements/BalanceTableActions'
import { useBalance } from './hooks/useBalance'

export const Balance = (): ReactElement => {
  const { organization } = useUserOrganization()
  const { report, isLoading, isIdle } = useBalance()

  if (organization?.countryId === 'NL') {
    return <BalanceSheetNL />
  }

  return (
    <>
      <BalanceTableActions />
      {isLoading || isIdle ? <ReportsSkeleton /> : <ReportHtml html={report?.html} />}
    </>
  )
}
